import React from 'react';
import { DOCUMENT_CUSTOM } from '../../../../../../config';
import DocumentDrop, { FileForUpload } from '../../../../../shared/DocumentDrop';
import { LocalDocument, UploadedDocument } from '@app/types/UploadADoc';

const DOCUMENT_UPLOAD_MAX_SIZE = 100; // in MB
const DOCUMENT_UPLOAD_MAX_TOTAL_SIZE = 100; // in MB

interface DocumentUploadProps {
    documents: (UploadedDocument | LocalDocument)[];
    handleFileUpload: (files: FileForUpload[]) => void;
    disabled?: boolean;
    disabledTooltipText?: string;
    allowMultiple?: boolean;
    documentType?: string;
    uploaderLabel?: string;
    documentLeaseType?: string;
    uploadProgressPercentage?: number;
    isUploading?: boolean;
    isMobile?: boolean;
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({
    documents,
    disabled = false,
    disabledTooltipText,
    allowMultiple = true,
    documentType,
    uploaderLabel,
    documentLeaseType = DOCUMENT_CUSTOM,
    uploadProgressPercentage,
    handleFileUpload,
    isMobile
}) => {
    const getDisabledStatusForMultipleUploads = () => {
        if (allowMultiple) {
            return false;
        }
        if (documentType) {
            return documents.some(d => d.documentType === documentType);
        }
        return documents.length > 0;
    };

    return (
        <React.Fragment>
            <DocumentDrop
                flattenPdfs={false}
                allowMultiple={allowMultiple}
                documents={documents}
                updateDocuments={(_, files) => handleFileUpload(files)}
                maxFileSize={DOCUMENT_UPLOAD_MAX_SIZE}
                maxTotalSize={DOCUMENT_UPLOAD_MAX_TOTAL_SIZE}
                rejectEncryptedPdfs
                documentLeaseType={documentLeaseType}
                disabled={disabled || getDisabledStatusForMultipleUploads()}
                disabledTooltipText={disabledTooltipText}
                label={uploaderLabel}
                isMobile={isMobile}
            />
            {uploadProgressPercentage !== undefined && (
                <div className="dropzone-spinner">
                    <span className="progress-value">{uploadProgressPercentage}%</span>
                    <label className="progress-line" style={{ width: `${uploadProgressPercentage}%` }} />
                </div>
            )}
        </React.Fragment>
    );
};

export default DocumentUpload;
